import { AnyAction } from 'redux'
import { actionTypes } from 'redux/actions/campaigns'

export interface CampaignData {
  baseline_ts: string
  campaign_type: number
  oid: string
  currency_symbol: string
  data_from_ts: string
  data_to_ts: string
  from_ts: string
  to_ts: string
  type: number
  title: string
  rank_by: number
  is_store_specific: boolean
  competition_type: number
}

export interface Campaign extends CampaignData {
  created_by: string
  status: number
  groups: string
  updated_by: string
  updated_at_ts: number
  created_at_ts: number
  users: string[]
  rid: string
  tags: string[]
}
export interface CampaignState {
  campaigns: Campaign[]
  loading: boolean
  isCampaignCreating: boolean
}

const initialState: CampaignState = {
  campaigns: [],
  loading: false,
  isCampaignCreating: false,
}

export const campaignsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload }
    case actionTypes.SET_CAMPAIGNS_LOADING:
      return { ...state, loading: action.payload }
    case actionTypes.SET_IS_CAMPAIGN_CREATING:
      return { ...state, isCampaignCreating: action.payload }
    case actionTypes.UPDATE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.map((c) => (c.oid === action.payload.oid ? action.payload : c)),
      }
    case actionTypes.DELETE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.filter((c) => c.oid !== action.payload),
      }
    default:
      return state
  }
}
